import { Grid, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import theme from '@theme';
import { alertIconsMap } from '../../iconMaps';
import styles from './AlertBanner.styles';

interface AlertBannerProps {
  ariaLabel?: string;
  bold?: boolean;
  className?: string;
  dataTestid?: string;
  rounded?: boolean;
  variant?: 'error' | 'success' | 'info';
  withIcon?: boolean;
  customIcon?: string;
}

const AlertBanner: FC<AlertBannerProps> = ({
  ariaLabel = 'Alert Banner',
  bold = false,
  children,
  className = '',
  dataTestid = 'errorText',
  rounded = false,
  variant = 'error',
  withIcon = false,
  customIcon,
}) => {
  const classes = styles({ variant, bold, rounded, brand: theme.name });

  const Icon = alertIconsMap[variant];

  return (
    <Grid className={`${classes.messageContainer} ${className}`} aria-label={ariaLabel}>
      {withIcon && (
        <div className={classes.icon}>
          <Icon />
        </div>
      )}
      {customIcon && <img src={customIcon} alt="icon" />}
      <div className={classes.messageWrapper}>
        <Typography
          className={classes.messageText}
          variant="body1"
          align="left"
          data-testid={`${dataTestid}-Error`}
        >
          {children}
        </Typography>
      </div>
    </Grid>
  );
};

export default AlertBanner;
